// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs .v-tabs-bar[data-v-469d2887]{height:50px}", ""]);
// Exports
module.exports = exports;
